module.exports = {
  "country": "LT",
  "artist": "The Roop",
  "song": "Discoteque",
  "year": "2021",
  "place": "8",
  "spotify": "7dMOzsTZOUtOF7W5kLN0gf"
};